import { render } from "./brandProfile.vue?vue&type=template&id=256474e7"
import script from "./brandProfile.vue?vue&type=script&lang=js"
export * from "./brandProfile.vue?vue&type=script&lang=js"

import "./brandProfile.vue?vue&type=style&index=0&id=256474e7&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__